import * as actionTypes from "constants/ActionTypes";

const integrators = (state = { isLoaded: false, data: [] }, action) => {
  switch (action.type) {
    case actionTypes.GET_INTEGRATORS.REQUEST:
      return {
        ...state,
        isLoaded: false,
      };
    case actionTypes.GET_INTEGRATORS.SUCCESS: {
      return {
        ...state,
        ...action.data,
        isLoaded: true,
      };
    }
    case actionTypes.GET_INTEGRATORS.FAILURE:
      return {
        ...state,
        ...action.data,
        isLoaded: true,
      };
    default:
      return state;
  }
};

export default integrators;



// WEBPACK FOOTER //
// ./app/reducers/integrators/integrators.js